import { render, staticRenderFns } from "./SetCourse.vue?vue&type=template&id=5c2e7592&"
import script from "./SetCourse.vue?vue&type=script&lang=js&"
export * from "./SetCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports